// ONE PROPERTY: The Obsidian Villa — Zurichberg, Zurich
// Consistent visual DNA: natural pale limestone + dark anodized aluminum frames,
// Calacatta Gold marble floors, brushed brass fixtures, Lake Zurich panorama

export const propertyData = {
  name: 'The Obsidian Villa',
  location: 'Zürichberg, Zürich',
  price: 'CHF 5.800.000',
  tagline: 'Wo Architektur auf Lebenskunst trifft.',
  description:
    'Inmitten des stillen Grüns des Zürichbergs entfaltet sich ein Raum, der Zeit vergessen lässt. Das Licht fällt hier anders – langsam, golden, wie ein leises Versprechen. Die Obsidian Villa ist keine Immobilie. Sie ist ein Gefühl. Eine Komposition aus Stille, Material und Aussicht, die solvente Menschen verstehen, ohne dass man es ihnen erklären müsste.',
  heroSlides: [
    {
      id: 1,
      url: 'https://public.readdy.ai/ai/img_res/36e252d81500d56b64cd038b8a3eb74b.jpg',
      caption: 'Südansicht & Infinity Pool',
    },
    {
      id: 2,
      url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20living%20room%2C%20Calacatta%20Gold%20marble%20floor%2C%20double-height%20ceiling%2C%20bespoke%20cream%20sofa%2C%20brushed%20brass%20and%20stone%20fireplace%20surround%2C%20floor-to-ceiling%20windows%20with%20Lake%20Zurich%20view%2C%20warm%20afternoon%20light%2C%20architectural%20interior%20photography&width=900&height=620&seq=6005&orientation=landscape',
      caption: 'Wohnzimmer & Zürichsee',
    },
    {
      id: 3,
      url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20heated%20infinity%20pool%20at%20twilight%2C%20pale%20limestone%20pool%20deck%2C%20warm%20illuminated%20pool%20water%20reflecting%20indigo%20sky%2C%20cream%20linen%20lounge%20chairs%2C%20Lake%20Zurich%20glistening%20below%2C%20dark%20anodized%20aluminum%20villa%20facade%20visible%20behind%2C%20architectural%20photography&width=1400&height=620&seq=2004&orientation=landscape',
      caption: 'Beheizter Infinity Pool · Panorama',
    },
    {
      id: 4,
      url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20kitchen%20and%20dining%20area%2C%20Bulthaup%20bespoke%20kitchen%20with%20brushed%20brass%20handles%2C%20Calacatta%20marble%20countertops%2C%20long%20marble%20dining%20table%2C%20eight%20cream%20upholstered%20chairs%2C%20panoramic%20windows%20facing%20Lake%20Zurich%2C%20natural%20daylight%2C%20architectural%20photography&width=900&height=620&seq=6006&orientation=landscape',
      caption: 'Küche & Esszimmer',
    },
  ],
  highlights: [
    { icon: 'ri-home-4-line', label: 'prop.label.area', value: '680 m²' },
    { icon: 'ri-landscape-line', label: 'prop.label.plot', value: '2.400 m²' },
    { icon: 'ri-hotel-bed-line', label: 'prop.label.bedrooms', value: '6' },
    { icon: 'ri-drop-line', label: 'prop.label.bathrooms', value: 'prop.val.bathrooms' },
    { icon: 'ri-building-line', label: 'prop.label.year', value: '2021' },
    { icon: 'ri-temp-hot-line', label: 'prop.label.pool', value: 'prop.val.pool' },
    { icon: 'ri-eye-line', label: 'prop.label.view', value: 'prop.val.view' },
    { icon: 'ri-car-line', label: 'prop.label.garage', value: 'prop.val.garage' },
  ],
  agent: {
    name: 'Dr. Alexandra Hartmann',
    title: 'Senior Luxury Property Advisor',
    phone: '+41 44 999 88 77',
    email: 'a.hartmann@obsidianproperties.ch',
    photo: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20Swiss%20luxury%20real%20estate%20advisor%20woman%20in%20tailored%20grey%20blazer%2C%20warm%20neutral%20studio%20background%2C%20confident%20and%20approachable%20expression%2C%20sophisticated%20appearance%2C%20high-end%20professional%20corporate%20photography%2C%20soft%20natural%20lighting&width=400&height=500&seq=3001&orientation=portrait',
  },
};

// Home page gallery — all rooms/areas of The Obsidian Villa
export const galleryImages = [
  {
    id: 1,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20open-plan%20living%20and%20kitchen%2C%20Calacatta%20Gold%20marble%20floors%2C%20bespoke%20oak%20and%20brushed%20brass%20kitchen%20island%2C%20floor-to-ceiling%20glazing%20with%20Lake%20Zurich%20panorama%2C%20cream%20and%20anthracite%20palette%2C%20natural%20afternoon%20light%20streaming%20in%2C%20architectural%20interior%20photography&width=800&height=1000&seq=2001&orientation=portrait',
    alt: 'Wohnbereich & Küche',
    label: '01',
    caption: 'Offener Wohnbereich',
  },
  {
    id: 2,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20double-height%20entrance%20hall%2C%20Calacatta%20marble%20floor%2C%20sculptural%20floating%20staircase%20with%20brushed%20brass%20handrails%2C%20abstract%20art%20on%20limestone%20plaster%20wall%2C%20diffused%20natural%20light%20from%20skylight%2C%20pale%20limestone%20walls%2C%20architectural%20photography%20with%20dramatic%20perspective&width=600&height=820&seq=2005&orientation=portrait',
    alt: 'Eingangshalle & Treppe',
    label: '02',
    caption: 'Eingangshalle',
  },
  {
    id: 3,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20master%20bedroom%2C%20low-profile%20linen%20bed%20with%20bespoke%20upholstered%20headboard%2C%20floor-to-ceiling%20windows%20with%20Lake%20Zurich%20panorama%2C%20cream%20linen%20curtains%2C%20warm%20morning%20light%2C%20Calacatta%20marble%20bedside%20tables%20with%20brass%20lamps%2C%20serene%20architectural%20interior&width=700&height=500&seq=2003&orientation=landscape',
    alt: 'Master Suite',
    label: '03',
    caption: 'Master Suite',
  },
  {
    id: 4,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20bathroom%20detail%2C%20Calacatta%20Gold%20marble%20wall%20panels%20and%20floor%2C%20freestanding%20stone%20bath%2C%20brushed%20brass%20Gessi%20tap%20fixtures%2C%20warm%20veined%20marble%20texture%2C%20soft%20diffused%20natural%20light%20from%20frosted%20skylight%2C%20minimalist%20luxury%20detail&width=700&height=500&seq=2002&orientation=landscape',
    alt: 'Marmor & Materialien',
    label: '04',
    caption: 'Badezimmer · Calacatta Marmor',
  },
  {
    id: 5,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20outdoor%20dining%20terrace%2C%20natural%20teak%20table%20with%20cream%20linen%20chairs%20under%20slim%20steel%20pergola%2C%20pale%20limestone%20terrace%20floor%2C%20Lake%20Zurich%20panorama%20visible%2C%20warm%20evening%20candle%20light%2C%20architectural%20exterior%20photography&width=700&height=500&seq=2006&orientation=landscape',
    alt: 'Terrasse & Dining',
    label: '05',
    caption: 'Terrasse & Outdoor Dining',
  },
  {
    id: 6,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20heated%20infinity%20pool%20at%20twilight%2C%20pale%20limestone%20pool%20deck%2C%20warm%20illuminated%20pool%20water%20reflecting%20indigo%20sky%2C%20cream%20linen%20lounge%20chairs%2C%20Lake%20Zurich%20glistening%20below%2C%20dark%20anodized%20aluminum%20villa%20facade%20visible%20behind%2C%20architectural%20photography&width=1400&height=620&seq=2004&orientation=landscape',
    alt: 'Infinity Pool & Zürichsee',
    label: '06',
    caption: 'Beheizter Infinity Pool · Panorama Zürichsee',
  },
];

// Extended gallery — all spaces of The Obsidian Villa for /galerie page
export const extendedGalleryImages = [
  {
    id: 101,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20south%20facade%20and%20infinity%20pool%2C%20natural%20pale%20limestone%20exterior%2C%20dark%20anodized%20aluminum%20window%20frames%2C%20heated%20pool%20in%20foreground%2C%20manicured%20terraced%20garden%2C%20Lake%20Zurich%20panorama%2C%20Zurichberg%2C%20golden%20hour%20cinematic%20architectural%20photography&width=900&height=620&seq=6001&orientation=landscape',
    alt: 'Südansicht & Pool',
    category: 'Aussen',
  },
  {
    id: 102,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20facade%20at%20night%2C%20natural%20pale%20limestone%20walls%2C%20dark%20anodized%20aluminum%20frames%2C%20warm%20amber%20interior%20light%20glowing%20from%20every%20floor-to-ceiling%20window%2C%20exterior%20landscape%20spotlights%2C%20dramatic%20contrast%20against%20deep%20night%20sky%2C%20architectural%20photography&width=900&height=620&seq=6002&orientation=landscape',
    alt: 'Abendansicht Fassade',
    category: 'Aussen',
  },
  {
    id: 103,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20private%20garden%20and%20terrace%2C%20pale%20limestone%20terrace%20floor%2C%20geometric%20clipped%20box%20hedges%2C%20ornamental%20trees%2C%20warm%20afternoon%20light%2C%20view%20toward%20villa%20limestone%20facade%2C%20elegant%20outdoor%20furniture%2C%20architectural%20landscape%20photography&width=900&height=620&seq=6003&orientation=landscape',
    alt: 'Garten & Terrasse',
    category: 'Aussen',
  },
  {
    id: 104,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20covered%20outdoor%20lounge%2C%20slim%20dark%20steel%20pergola%20attached%20to%20limestone%20facade%2C%20cream%20outdoor%20deep%20sofas%2C%20teak%20coffee%20table%2C%20gas%20fire%20pit%2C%20Lake%20Zurich%20view%2C%20warm%20sunset%20light%2C%20architectural%20exterior%20photography&width=900&height=620&seq=6004&orientation=landscape',
    alt: 'Outdoor Lounge',
    category: 'Aussen',
  },
  {
    id: 105,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20living%20room%2C%20Calacatta%20Gold%20marble%20floor%2C%20double-height%20ceiling%2C%20bespoke%20cream%20sofa%2C%20brushed%20brass%20and%20stone%20fireplace%20surround%2C%20floor-to-ceiling%20windows%20with%20Lake%20Zurich%20view%2C%20warm%20afternoon%20light%2C%20architectural%20interior%20photography&width=900&height=620&seq=6005&orientation=landscape',
    alt: 'Wohnzimmer',
    category: 'Innen',
  },
  {
    id: 106,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20kitchen%20and%20dining%20area%2C%20Bulthaup%20bespoke%20kitchen%20with%20brushed%20brass%20handles%2C%20Calacatta%20marble%20countertops%2C%20long%20marble%20dining%20table%2C%20eight%20cream%20upholstered%20chairs%2C%20panoramic%20windows%20facing%20Lake%20Zurich%2C%20natural%20daylight%2C%20architectural%20photography&width=900&height=620&seq=6006&orientation=landscape',
    alt: 'Küche & Esszimmer',
    category: 'Innen',
  },
  {
    id: 107,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20private%20library%20and%20study%2C%20floor-to-ceiling%20natural%20walnut%20bookshelves%20with%20brass%20ladders%2C%20Calacatta%20marble%20desk%20surface%2C%20dark%20leather%20chair%2C%20warm%20reading%20lamp%2C%20Persian%20rug%20on%20marble%20floor%2C%20architectural%20interior%20photography&width=900&height=620&seq=6007&orientation=landscape',
    alt: 'Bibliothek & Arbeitszimmer',
    category: 'Innen',
  },
  {
    id: 108,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20master%20bedroom%2C%20bespoke%20linen%20upholstered%20king%20bed%2C%20Calacatta%20marble%20nightstands%20with%20brushed%20brass%20lamps%2C%20floor-to-ceiling%20windows%20with%20Lake%20Zurich%20panorama%2C%20cream%20curtains%20in%20morning%20light%2C%20serene%20architectural%20interior%20photography&width=900&height=620&seq=6008&orientation=landscape',
    alt: 'Master Bedroom',
    category: 'Innen',
  },
  {
    id: 109,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20master%20bathroom%2C%20freestanding%20oval%20Calacatta%20stone%20bathtub%2C%20floor-to-ceiling%20Calacatta%20Gold%20marble%20walls%20and%20floor%2C%20double%20vanity%20with%20brushed%20brass%20Gessi%20fixtures%2C%20natural%20light%20from%20frosted%20skylight%2C%20minimalist%20luxury%20architectural%20interior&width=900&height=620&seq=6009&orientation=landscape',
    alt: 'Master Badezimmer',
    category: 'Details',
  },
  {
    id: 110,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20material%20detail%2C%20Calacatta%20Gold%20marble%20floor%20meeting%20pale%20limestone%20plaster%20wall%2C%20brushed%20brass%20skirting%20trim%2C%20ultra-luxury%20architectural%20material%20detail%20photography%2C%20warm%20soft%20light%2C%20minimalist%20luxury&width=900&height=620&seq=6010&orientation=landscape',
    alt: 'Calacatta Marmor Detail',
    category: 'Details',
  },
  {
    id: 111,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20private%20wine%20cellar%2C%20natural%20limestone%20walls%2C%20bespoke%20oak%20wine%20racks%20with%20brass%20labels%2C%20warm%20dramatic%20spotlight%20lighting%2C%20marble%20tasting%20table%2C%20atmospheric%20dark%20tone%2C%20residential%20luxury%20photography&width=900&height=620&seq=6011&orientation=landscape',
    alt: 'Weinkeller',
    category: 'Details',
  },
  {
    id: 112,
    url: 'https://readdy.ai/api/search-image?query=The%20Obsidian%20Villa%20indoor%20wellness%20spa%2C%20natural%20stone%20walls%20matching%20exterior%20limestone%2C%20indoor%20plunge%20pool%2C%20natural%20oak%20sauna%20door%2C%20brushed%20brass%20fixtures%2C%20warm%20amber%20indirect%20lighting%2C%20serene%20high-end%20residential%20wellness%20photography&width=900&height=620&seq=6012&orientation=landscape',
    alt: 'Wellness & Spa',
    category: 'Details',
  },
];
